import './DropDownButton.component.scss';

export type DropDownButtonProps = {
  label: string;
  isActive?: boolean;
  icon?: React.ReactNode;
  color?: string;
  onClick?: (e?: React.MouseEvent) => void;
  'data-tooltip'?: string;
};

const DropDownButton = ({ label, icon, onClick, color, isActive, 'data-tooltip': dataTooltip }: DropDownButtonProps) => {
  return (
    <div 
      className={`ui-dropdown-button${isActive ? ' active' : ''}`} 
      onClick={onClick}
      data-tooltip={!isActive ? dataTooltip : undefined}
    >
      <div className="ui-dropdown-button__icon" style={{ color: color }}>
        {icon}
      </div>
      <div className="ui-dropdown-button__content">
        <i className="ui-dropdown-button__content__icon material-icons">arrow_drop_up</i>
        <div className="ui-dropdown-button__content__title">
          {label}
        </div>  
      </div>
    </div>
  );
};

export default DropDownButton;
